export const editorAreas = [
  "model" as const,
  "variables" as const,
  "inspector" as const,
  "simulation" as const,
  "evaluation" as const
];

export type EditorAreaName = (typeof editorAreas)[keyof typeof editorAreas &
  number];
